import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';
import api from './api';
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/Common/ScrollToTop';

// 共通
import ActivateAccountPage from './pages/Common/ActivateAccountPage';
import PrivacyPolicyPage from './pages/Common/PrivacyPolicyPage';

// 顧客
import CustomerIndex from './pages/Customer/CustomerIndex';
import CustomerTopPage from './pages/Customer/CustomerTopPage';
import CustomerLoginPage from './pages/Customer/CustomerLoginPage';
import CustomerDashboard from './components/Customer/CustomerDashboard';
import CustomerAccountPage from './pages/Customer/CustomerAccountPage';
import CustomerProgress from './components/Customer/CustomerProgress';
import SearchContractor from './components/Customer/SearchContractor';
import ContractorDetailPage from './pages/Customer/ContractorDetailPage';
import ConditionInputPage from './pages/Customer/ConditionInputPage';
import ProjectChatPage from './pages/Customer/ProjectChatPage';
import EstimateViewPage from './pages/Customer/EstimateViewPage';
import ContractorDecisionPage from './pages/Customer/ContractorDecisionPage';
import InvoiceViewPage from './pages/Customer/InvoiceViewPage';
import CompletionConfirmPage from './pages/Customer/CompletionConfirmPage';
import ReviewPage from './pages/Customer/ReviewPage';

// 業者
import ContractorLoginPage from './pages/Contractor/ContractorLoginPage';
import ContractorLanding from './pages/Contractor/ContractorLanding';
import ContractorProfilePage from './pages/Contractor/ContractorProfilePage';
import ContractorDashboard from './pages/Contractor/ContractorDashboard';
import ContractorProjectPage from './pages/Contractor/ContractorProjectPage';
import ContractorChatPage from './pages/Contractor/ContractorChatPage';
import EstimateCreatePage from './pages/Contractor/EstimateCreatePage';
import EstimatePreviewPage from './pages/Contractor/EstimatePreviewPage';
import InvoiceCreatePage from './pages/Contractor/InvoiceCreatePage';
import InvoicePreviewPage from './pages/Contractor/InvoicePreviewPage';
import ScheduleCreatePage from './pages/Contractor/ScheduleCreatePage';
import ContractorProgressPage from './pages/Contractor/ContractorProgressPage';
import ContractorDocumentsPage from './pages/Contractor/ContractorDocumentsPage';

// 管理者
import AdminPayoutPage from './pages/Admin/AdminPayoutPage';
import AdminDashboardPage from './pages/Admin/AdminDashboardPage';
import AdminProjectListPage from './pages/Admin/AdminProjectListPage';
import AdminProjectDetailPage from './pages/Admin/AdminProjectDetailPage';
import AdminContractorListPage from './pages/Admin/AdminContractorListPage';
import AdminLoginPage from './pages/Admin/AdminLoginPage';

// 旧ページ（後方互換）
import ContractorPages from './pages/Contractor/ContractorIndex';
import TaskList from './components/Task/TaskList';
import CustomerList from './components/Contractor/CustomerList';


const App = () => {
    return (
        <Router>
            <ScrollToTop />
            <Layout>
                <Routes>
                    {/* 共通 */}
                    <Route path="/" element={<CustomerTopPage />} />
                    <Route path="/activate/:uid/:token/" element={<ActivateAccountPage />} />
                    <Route path="/privacy" element={<PrivacyPolicyPage />} />

                    {/* 顧客認証 */}
                    <Route path="/customer/login" element={<CustomerLoginPage />} />

                    {/* 顧客ポータル */}
                    <Route path="/customer/dashboard" element={<CustomerDashboard />} />
                    <Route path="/customer/progress" element={<CustomerProgress />} />
                    <Route path="/customer/search" element={<SearchContractor />} />
                    <Route path="/customer/account" element={<CustomerAccountPage />} />

                    {/* 顧客フロー */}
                    <Route path="/customer/contractor/:contractorId" element={<ContractorDetailPage />} />
                    <Route path="/customer/condition" element={<ConditionInputPage />} />
                    <Route path="/customer/chat/:projectId" element={<ProjectChatPage />} />
                    <Route path="/customer/estimate/:projectId" element={<EstimateViewPage />} />
                    <Route path="/customer/decision/:projectId" element={<ContractorDecisionPage />} />
                    <Route path="/customer/invoice/:projectId" element={<InvoiceViewPage />} />
                    <Route path="/customer/completion/:projectId" element={<CompletionConfirmPage />} />
                    <Route path="/customer/review/:projectId" element={<ReviewPage />} />

                    {/* 業者認証 */}
                    <Route path="/contractor/register" element={<ContractorLanding />} />
                    <Route path="/contractor/login" element={<ContractorLoginPage />} />

                    {/* 業者ポータル */}
                    <Route path="/contractor/dashboard" element={<ContractorDashboard />} />
                    <Route path="/contractor/progress" element={<ContractorProgressPage />} />
                    <Route path="/contractor/documents" element={<ContractorDocumentsPage />} />
                    <Route path="/contractor/profile" element={<ContractorProfilePage />} />
                    <Route path="/contractor/project/:projectId" element={<ContractorProjectPage />} />
                    <Route path="/contractor/chat/:projectId" element={<ContractorChatPage />} />
                    <Route path="/contractor/estimate/create/:projectId" element={<EstimateCreatePage />} />
                    <Route path="/contractor/estimate/preview/:projectId" element={<EstimatePreviewPage />} />
                    <Route path="/contractor/invoice/create/:projectId" element={<InvoiceCreatePage />} />
                    <Route path="/contractor/invoice/preview/:projectId" element={<InvoicePreviewPage />} />
                    <Route path="/contractor/schedule/:projectId" element={<ScheduleCreatePage />} />

                    {/* 管理者 */}
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                    <Route path="/admin/projects" element={<AdminProjectListPage />} />
                    <Route path="/admin/projects/:id" element={<AdminProjectDetailPage />} />
                    <Route path="/admin/payouts" element={<AdminPayoutPage />} />
                    <Route path="/admin/contractors" element={<AdminContractorListPage />} />
                </Routes>
            </Layout>
        </Router>
    );
};

export default App;
